import { motion } from 'framer-motion'
import Masonry from 'react-masonry-css'
import { ISbComponentType } from 'storyblok-js-client'
import { CustomLink } from '../../components/CustomLink'
import { Grid } from '../../components/Grid'
import ListingCard from '../../components/ListingCard'
import { Columns } from '../../components/ListingGrid'
import ResponsiveProjects from '../../components/ListingGrid/ProjectsSlider'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import { IMAGE_FILTER } from '../../utils/detectWebPSupported'
import { withSlice } from '../SliceComponent'
import classes from './similarProjects.module.scss'

type SimilarProjectsProps = ISbComponentType<'similar_projects_list'> & {
  slice: {
    projects:{
      link: {
        cached_url: string
      }
      image: {
        filename: string
      }
      title: string
      subtitle: string
    }[]
    title: string
  }
}

type SimilarProjectsFormat = { id: number
image?: string
brand?: string
description?: string
url?: string
category?: string
} | false

export const SimilarProjects = ({ slice }: SimilarProjectsProps)=> {
  const similarProjects: SimilarProjectsFormat[] = []
  const isMobile = useMediaQuery('(max-width: 1024px)')

  slice.projects.map((project, idx) => {
    similarProjects.push({
      url: project.link.cached_url,
      id: idx,
      image: `${project?.image.filename}${IMAGE_FILTER}`,
      brand: project?.title,
      description: project?.subtitle,
    })
  })

  return (
    <div style={{ overflow: 'hidden', width: '100%' }}>
      {!isMobile && classes?.masonryGrid ? (
        <Grid container className={classes.listingGrid}>
          <Grid className={classes.titleContainer} ><h2>{slice.title}</h2></Grid>
          <Masonry
            breakpointCols={Columns}
            className={classes.masonryGrid}
            columnClassName={classes.masonryColumn}
          >
            {similarProjects.map((item, idx) => item !== false && (<ListingCard key={idx} data={item} />))}
          </Masonry>
          <motion.div className={classes.buttonContainer} >
            <CustomLink
              href={'/projects'}
              variant={'primary-with-arrow'}
            >
              View all case studies
            </CustomLink>
          </motion.div>
        </Grid>
      ): (
        <ResponsiveProjects data={similarProjects}/>
      )}
    </div>
  )
}


export default withSlice(SimilarProjects)
